export default __webpack_public_path__ + "static/media/cheers-mate.cb7efeb2.gif";